<template>
  <section class="px-16 mt-8">
    <loading-flux :value="loading"></loading-flux>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <section class="d-flex flex-wrap gap-10">
          <div class="d-flex gap-10" id="name">
            <v-tooltip top v-if="isPresale && !appIsLoadedInIframe">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class=""
                  @click="$router.push('/?presale_tab=true')"
                  size="lg"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-arrow-left
                </v-icon>
              </template>
              <span>Volver</span>
            </v-tooltip>
            <div id="titleContainer" class="d-flex align-items-center mt-2">
              <h4>
                Documentos de {{ getTitleFromIsProjectOrPresale }}
                {{ getCodeFromIsProjectOrPresale }}
                {{ getNameFromIsProjectOrPresale }}
              </h4>
            </div>
          </div>
          <v-chip
            v-if="totalPercentageProjectOrPresale && !loadingDocuments"
            color="grey darken-1"
            id="chip"
            class="d-flex justify-content-center mt-1 mx-2"
          >
            <span style="font-size: 12px;" class="mx-5 text-white">
              Avance Documental Total:
              {{ totalPercentageProjectOrPresale.completion_percentage }} %
            </span>
          </v-chip>
          <v-chip
            v-if="appIsLoadedInIframe && isPresale"
            color="primary darken-1"
            id="chip"
            class="d-flex justify-content-center mt-1 mx-2"
          >
            <span style="font-size: 12px;" class="mx-5 text-white">
              Estatus de la preventa:
              <b>
                {{ $route.query.approved_status ? $route.query.approved_status : "N/A" }}
              </b>
            </span>
          </v-chip>
          <div
            id="buttons"
            class="d-flex flex-wrap justify-content-center gap-10 mt-1"
          >
            <v-btn
              v-if="permissionToEditMaintainerDocument"
              @click="openModalMaintainers()"
              color="warning"
              :disabled="loadingDocuments"
              :dark="false"
              outlined
              x-small
              class="text-white py-4"
            >
              <i class="mdi mdi-pencil me-1"></i>
              Modificar Estructura
            </v-btn>

            <v-btn
              x-small
              :color="sellOrderPresale ? 'warning' : 'primary'"
              :disabled="loadingDocuments || !isPresaleReadyToCreateProject"
              :dark="false"
              class="text-white py-4"
              @click="openModalCreateProjectFromPresale()"
              v-if="
                isPresale &&
                  isEnabledCreateButton &&
                  (statusPresale == STATUS_PRESALE_SIGNED ||
                    statusPresale == null ||
                    statusPresale == STATUS_PRESALE_PENDING_SIGNED ||
                    statusPresale == STATUS_PRESALE_REVIEW_USER)
              "
            >
              <i
                :class="sellOrderPresale ? 'mdi mdi-pencil' : 'mdi mdi-plus'"
              ></i>
              {{
                sellOrderPresale && statusPresale == STATUS_PRESALE_REVIEW_USER
                  ? "Modificar información de Cliente y Proyecto"
                  : "Crear Proyecto SAP"
              }}
            </v-btn>
            <v-btn
              x-small
              color="primary"
              class="text-white py-4"
              @click="changePresaleStatus(STATUS_PRESALE_REVIEW_PENDING)"
              v-if="
                isPresale &&
                  isEnabledCreateButton &&
                  statusPresale == STATUS_PRESALE_REVIEW_USER
              "
            >
              <v-icon small color="white" class="mr-2">
                mdi-check-circle-outline
              </v-icon>
              Enviar a Pendiente de Revisión
            </v-btn>
            <!-- Modulo de Firma de Contrato -->
            <sign-contract :isPresale="isPresale"></sign-contract>
            <v-btn
              x-small
              @click="openModalFilterDocuments()"
              color="primary"
              outlined
              :disabled="loadingDocuments"
              :dark="false"
              class="text-white py-4"
            >
              <i class="mdi mdi-filter me-1"></i>
              Filtros
            </v-btn>
            <v-btn
              x-small
              outlined
              :disabled="loadingDocuments || !documents.length"
              @click="openModalUploadDocument(null)"
              color="primary"
              :dark="false"
              class="text-white py-4"
            >
              <i class="mdi mdi-upload me-1"></i>
              Cargar Nuevo Documento
            </v-btn>
          </div>
        </section>
      </v-col>

      <v-col cols="12" md="11" sm="12" class="px-8">
        <div v-if="loadingDocuments" class="d-flex justify-content-center">
          <p class="text-center">Cargando Documentos... Espere por favor</p>
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            class="mx-auto"
            indeterminate
          ></v-progress-circular>
        </div>

        <v-treeview
          shaped
          v-else-if="documents.length"
          :open="foldersOpened"
          v-model="documentsTree"
          :items="documents"
          item-key="id"
          open-on-click
          @update:open="foldersOpened = $event"
          :hoverable="false"
        >
          <template v-slot:label="{ item, open }">
            <div class="d-flex align-items-center" v-if="item.children">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    @click="open = !open"
                    class="mr-1"
                    :color="
                      isPresale &&
                      !item.is_pre_project_ready &&
                      !isPresaleNotBusinessUnitResidential
                        ? 'orange'
                        : ''
                    "
                    v-bind="attrs"
                    v-on="!item.is_pre_project_ready && isPresale ? on : null"
                  >
                    {{
                      isPresale &&
                      !item.is_pre_project_ready &&
                      !isPresaleNotBusinessUnitResidential
                        ? "mdi-folder-alert"
                        : open
                        ? "mdi-folder-open"
                        : "mdi-folder"
                    }}
                  </v-icon>
                </template>
                <span>
                  {{
                    isPresale &&
                    !item.is_pre_project_ready &&
                    !isPresaleNotBusinessUnitResidential
                      ? "Esta carpeta tiene documentos requeridos para crear y enlazar proyecto que no han sido cargados"
                      : ""
                  }}
                </span>
              </v-tooltip>
              ({{ item.documents_count ? item.documents_count : 0 }})
              <h5 class="mt-2 mx-2" v-if="item.children">
                {{ item.name }}
                <v-tooltip
                  top
                  v-if="
                    !isPresaleNotBusinessUnitResidential && IsSaleFolder(item)
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="mx-1 text-primary"
                      style="font-size: 1.5rem"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-information
                    </v-icon>
                  </template>
                  <span>
                    Webdox admite archivos en los siguientes formatos: .doc,
                    .docx y .pdf.
                  </span>
                </v-tooltip>
                <small
                  v-if="checkForDocuments(item)"
                  class="mx-5 text-primary font-weight-bold"
                >
                  Avance Documental: {{ item.completion_percentage }} %</small
                >
              </h5>
            </div>
            <v-simple-table dense v-else class="mt-2">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left px-2">
                      <h6 class="font-weight-bold">Acción</h6>
                    </th>
                    <th class="text-left px-1">
                      <h6 class="font-weight-bold">Documento</h6>
                    </th>
                    <th class="text-center px-1">
                      <h6 class="font-weight-bold">Área Responsable</h6>
                    </th>
                    <th class="text-center px-1">
                      <h6 class="font-weight-bold">Nombre de Documento</h6>
                    </th>
                    <th class="text-center px-1">
                      <h6 class="font-weight-bold">Comentario</h6>
                    </th>
                    <th class="text-center px-1">
                      <h6 class="font-weight-bold">Fecha Subida</h6>
                    </th>
                    <th class="text-center px-1">
                      <h6 class="font-weight-bold">Último Cambio</h6>
                    </th>
                    <th class="text-center px-1">
                      <h6 class="font-weight-bold">Vencimiento</h6>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="document in item.documents" :key="document.id">
                     <td class="text-center">
                       <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-if="
                              isPresale &&
                                document.pre_project_locked &&
                                !document.upload &&
                                !isPresaleNotBusinessUnitResidential
                            "
                            class="float-left mr-2"
                            color="warning"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-file-alert
                          </v-icon>
                        </template>
                        <span
                          >Este archivo es requerido para crear y enlazar el
                          proyecto</span
                        >
                      </v-tooltip>                   
                    </td>
                    <td class="text-center">
                    
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            @click="sendDeleteDocument(document)"
                            class="float-left"
                            color="red"
                            :disabled="!document.upload"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Eliminar Documento</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            @click="openModalUploadDocument(document)"
                            class="float-left mx-2"
                            color="warning"
                            :disabled="!document.upload"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>
                        <span>Editar Documento</span>
                      </v-tooltip>
                    </td>
                    <td>
                      <div class="text-left">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="!document.upload"
                              @click="openModalUploadDocument(null, document)"
                              class="mx-2"
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-file-upload
                            </v-icon>
                          </template>
                          <span>Cargar Documento</span>
                        </v-tooltip>
                        <v-btn
                          v-if="document.upload"
                          icon
                          @click="
                            document.upload
                              ? openModalPreviewDocument(document)
                              : openModalUploadDocument(null, document)
                          "
                          target="_blank"
                        >
                          <v-icon class="mx-2">
                            {{
                              getIconMaterialFromExtension(document.extension)
                            }}
                          </v-icon>
                        </v-btn>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              class="mt-1 mx-0"
                              color="orange"
                              v-bind="attrs"
                              v-on="on"
                              v-if="document.is_cubicacion"
                            >
                              mdi-cube-outline
                            </v-icon>
                          </template>
                          <span>Documento de Cubicación</span>
                        </v-tooltip>
                      </div>
                    </td>
                    <td>
                      <div class="text-center">
                        <v-chip
                          label
                          small
                          ripple
                          :color="
                            !document.upload ? 'grey darken-1' : 'teal accent-4'
                          "
                          class="text-white"
                        >
                          {{ document.document_type.assigned_area.name }}
                        </v-chip>
                      </div>
                    </td>
                    <td>
                      <p class="my-0 mx-2">
                        {{ document.document_type.name }}
                      </p>
                    </td>
                    <td>
                      <p class="my-0 mx-0">
                        {{ document.comment }}
                      </p>
                    </td>
                    <td>
                      <p class="my-0 mx-0">
                        {{
                          document.upload
                            ? formatDate(document.created_at)
                            : "-"
                        }}
                      </p>
                    </td>
                    <td>
                      <p class="my-0 mx-0">
                        {{
                          document.upload
                            ? formatDate(document.updated_at)
                            : "-"
                        }}
                      </p>
                    </td>
                    <td>
                      <div v-if="document.expiration_date" class="text-center">
                        <v-chip
                          label
                          small
                          :color="getExpirationStatus(document.expiration_date).color"
                          class="text-white"
                        >
                          {{ formatDate(document.expiration_date) }}
                        </v-chip>
                        <br />
                        <small>{{ getExpirationStatus(document.expiration_date).label }}</small>
                      </div>
                      <p v-else class="my-0 mx-0 text-center">-</p>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </v-treeview>
        <div v-else class="text-center mt-16">
          <v-icon size="50" color="warning">mdi-alert-circle</v-icon>
          <h5 class="mt-5">No hay Documentos para Mostrar</h5>
        </div>
      </v-col>
    </v-row>
    <modal-maintainers
      :modalAction="dialogMaintainers"
      :closeModalMaintainers="closeModalMaintainers"
      :isProject="isProject"
      :isPresale="isPresale"
      @folderCreatedOrUpdated="getDocumentsData"
      @updateNameDocumentDeleted="getDocumentsData"
    >
    </modal-maintainers>
    <modal-upload-document
      ref="modalUploadDocument"
      :modalAction="dialogUploadDocument"
      :closeModalUploadDocument="closeModalUploadDocument"
      :isProject="isProject"
      :isPresale="isPresale"
      :currentDocument="currentDocument"
      @documentCreatedOrUpdated="getDocumentsData"
    >
    </modal-upload-document>
    <modal-create-project-from-presale
      ref="modalCreateProjectFromPresale"
      :modalAction="dialogCreateProjectFromPresale"
      :closeModalCreateProjectFromPresale="closeModalCreateProjectFromPresale"
      @projectCreated="changeQueryParamHaveProject"
      :projectInfo="sellOrderPresale"
      :client="clientPresale"
    >
    </modal-create-project-from-presale>
    <modal-preview-document
      :modalAction="dialogPreviewDocument"
      :closeModalPreviewDocument="closeModalPreviewDocument"
      :documentName="currentDocumentName"
      :currentDocument="currentDocument"
      @downloadFile="downloadFile"
    >
    </modal-preview-document>
    <filters
      :modalAction="dialogFilterDocuments"
      :closeModalFilterDocuments="closeModalFilterDocuments"
      @clearAllFilters="clearAllFilters"
      @searchFilters="searchFilters"
    >
    </filters>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getIconMaterialFromExtension } from "@/helpers/document";
import { formatDateMomentToHuman } from "@/helpers/common";
import { authUsuarioComputed } from "@/state/helpers";
import roles from "@/mixins/roles";
import config from "@/config";
import {
  COST_CENTER_MANAGMENT_CONTROL,
  NEW_COST_CENTER_MANAGMENT_CONTROL,
} from "@/constants/common";
import {
  PERMISSION_FROM_BUSINESS_UNIT_TO_MODIFY_MAINTAINER_DOCUMENTS,
  PERMISSION_FOR_CECO,
  BUSINESS_UNIT_RESIDENTIAL_CODE,
  STATUS_PRESALE_APPROVED,
  STATUS_PRESALE_REVIEW_PENDING,
  STATUS_PRESALE_PENDING_SIGNED,
  STATUS_PRESALE_REVIEW_USER,
  STATUS_PRESALE_SIGNED,
  NAME_FOLDER_SALE_RESIDENTIAL,
} from "@/constants/presale";
import ModalPreviewDocument from "./components/ModalPreviewDocument.vue";
import ModalMaintainers from "./components/ModalMaintainers.vue";
import ModalCreateProjectFromPresale from "../presale/components/ModalCreateProjectFromPresale.vue";
import ModalUploadDocument from "./components/ModalUploadDocument.vue";
import Filters from "./components/Filters.vue";
import SignContract from "../presale/components/signContract/index.vue";
import { isProjectLoadedInIframe } from "@/helpers/common";
export default {
  mixins: [roles],
  components: {
    ModalUploadDocument,
    Filters,
    ModalMaintainers,
    ModalCreateProjectFromPresale,
    ModalPreviewDocument,
    SignContract,
  },
  data() {
    return {
      STATUS_PRESALE_APPROVED,
      STATUS_PRESALE_REVIEW_PENDING,
      STATUS_PRESALE_REVIEW_USER,
      STATUS_PRESALE_SIGNED,
      STATUS_PRESALE_PENDING_SIGNED,
      dialogFilterDocuments: false,
      dialogUploadDocument: false,
      dialogPreviewDocument: false,
      dialogMaintainers: false,
      dialogCreateProjectFromPresale: false,
      currentDocument: null,
      currentProject: null,
      currentDocumentName: null,
      documentsTree: [],
      foldersOpened: [],
      selectedDocuments: [],
      debounce: null,
      debounceTime: 500,
      filters: {
        filter: "",
        document_type_filter: null,
        assigned_area_filter: null,
        date_start: null,
        date_end: null,
        onlyFolders: true,
        onlySubFolders: true,
        onlyNameDocuments: true,
      },
      loading: false,
      loadingDocuments: false,

      //Datos de la orden de venta de la preventa
      statusPresale: this.$route.query.approved_status,
      sellOrderPresale: null,
      clientPresale: null,
    };
  },
  props: {
    isProject: {
      type: Boolean,
      default: false,
    },
    isPresale: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getDocumentsData();
    this.getProjectOrPresale();
    this.getAssignedAreas();
    this.getEmployeeData();
    this.getSellOrderPresaleData();
  },
  methods: {
    ...mapActions({
      getTotalPercentageProjectOrPresale:
        "project/getTotalPercentageProjectOrPresale",
      getAllPresales: "presale/getAllPresales",
      getProjectFromCode: "project/getProjectFromCode",
      getDocuments: "document/getDocuments",
      deleteDocument: "document/deleteDocument",
      sendDownloadFile: "document/downloadFile",
      showPresale: "presale/showPresale",
      getAssignedAreas: "document/getAssignedAreas",
      getEmployees: "maintainers/getEmployees",
      getSellOrderFromPresale: "presale/getSellOrderFromPresale",
      updateStatusPresale: "presale/updateStatusPresale",
      registerLogViewDocument: "document/registerLogViewDocument",
    }),
    changePresaleStatus(status) {
      let message =
        status == STATUS_PRESALE_APPROVED
          ? `Aprobar y Crear Proyecto en SAP`
          : status == STATUS_PRESALE_REVIEW_USER
          ? `Enviar a Revisión por Usuario`
          : `Enviar a Pendiente de Revisión`;
      this.$swal
        .fire({
          icon: STATUS_PRESALE_REVIEW_USER ? "warning" : "info",
          title:
            `¿Estás seguro de ${message} la Preventa con código: ` +
            "<b>" +
            `${this.$route.params.codePresale || this.$route.query.code }` +
            "</b>" +
            "?",
          text: "",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#4285F4",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            this.loading = true;
            const resp = await this.updateStatusPresale({
              preventa_id: this.$route.query.presale_code,
              user: this.user.email,
              status,
            });
            if (resp.status == 200) {
              this.$swal.fire({
                icon: "success",
                title: "Excelente",
                text: `El estatus de la Preventa ha sido actualizado correctamente a ${status}`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 7000,
                timerProgressBar: true,
              });
              this.statusPresale = status;
              const currentParams = {
                ...this.$route.query,
                approved_status: status,
              };
              this.$router.push({ query: currentParams });
            }
            if (!resp.status || resp.status === 400) {
              this.loading = false;
              return this.$swal.fire({
                icon: "error",
                title: "Error",
                text: resp.data.detail?.error
                  ? resp.data.detail.error.message
                  : resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 10000,
                timerProgressBar: true,
              });
            }
            this.loading = false;
          }
        });
    },
    async getSellOrderPresaleData() {
      //Validar si hay estatus de preventa y si aun no esta aprobada
      if (
        this.statusPresale &&
        this.statusPresale !== STATUS_PRESALE_APPROVED
      ) {
        const resp = await this.getSellOrderFromPresale({
          pre_project_id: this.$route.query.presale_code,
        });
        if (resp.data && resp.data.data.length) {
          this.sellOrderPresale = resp.data.data[0];
          if (resp.data.data[0].empresa_rut) {
            this.$refs.modalCreateProjectFromPresale.setTypeClientCompany();
          }
          this.clientPresale = resp.data.data[0].empresa_rut
            ? resp.data.data[0].empresa_rut
            : resp.data.data[0].client_rut;
        }
      }
    },
    async getEmployeeData() {
      let self = this;
      await self.getEmployees({
        password: config.password_manteiners,
        page: 0,
        filter: this.user.email,
      });
    },
    async getProjectOrPresale() {
      if (this.isPresale) {
        await this.showPresale({
          pre_project_id: this.$route.query.presale_code,
        });
      } else {
        const resp = await this.getProjectFromCode({
          code: this.getCodeProjectFromParamsOrQuery,
        });
        await this.showPresale({
          project_id: resp.id,
        });
        this.currentProject = resp;
      }
      await this.getAssignedAreas({
        business_unit_filter: this.currentPresale.business_unit.code,
      });
    },
    async downloadFile(documentFile) {
      const response = await fetch(documentFile.url.replace(/%/g, "%25"), {
        method: "GET",
      });
      const filename = this.isPresale
        ? `${this.$route.params.codePresale || this.$route.query.code}-${this.$route.query.presale_name}-${documentFile.document_type.name}.${documentFile.extension}`
        : `${this.getCodeProjectFromParamsOrQuery}-${
            this.currentProject ? this.currentProject.name : "proyecto"
          }-${
            documentFile && documentFile.document_type
              ? documentFile.document_type.name
              : "documento"
          }.${documentFile.extension}`;
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    },
    searchFilters(filters) {
      this.filters.document_type_filter = filters.document_type_filter;
      this.filters.assigned_area_filter = filters.assigned_area_filter;
      this.filters.date_start = filters.date_start;
      this.filters.date_end = filters.date_end;
      this.filters.filter = filters.filter;
      this.filters.onlyFolders = filters.onlyFolders;
      this.filters.onlySubFolders = filters.onlySubFolders;
      this.filters.onlyNameDocuments = filters.onlyNameDocuments;
      this.getDocumentsData();
    },
    clearAllFilters() {
      this.filters.document_type_filter = null;
      this.filters.assigned_area_filter = null;
      this.filters.date_start = null;
      this.filters.date_end = null;
      this.filters.filter = "";
      this.filters.onlyFolders = true;
      this.filters.onlySubFolders = true;
      this.filters.onlyNameDocuments = true;
      this.getDocumentsData();
    },
    formatDate(date) {
      return formatDateMomentToHuman(date);
    },
    getExpirationStatus(expirationDate) {
      if (!expirationDate) return { color: "grey", label: "Sin fecha" };
      const now = new Date();
      const exp = new Date(expirationDate);
      const diffDays = Math.ceil((exp - now) / (1000 * 60 * 60 * 24));
      if (diffDays < 0) return { color: "red", label: `Vencido hace ${Math.abs(diffDays)} días` };
      if (diffDays <= 30) return { color: "orange", label: `Vence en ${diffDays} días` };
      return { color: "green", label: `Vence en ${diffDays} días` };
    },
    changeQueryParamHaveProject() {
      // const currentParams = { ...this.$route.query, have_project: true };
      // this.$router.push({ query: currentParams });
      if(this.appIsLoadedInIframe){
        //Recargar pagina
        setTimeout(() => {
          window.location.reload();
          return
        }, 4000);
      }
      setTimeout(() => {
        this.$router.push("/?presale_tab=true");
      }, 4000);
    },
    async getDocumentsData() {
      clearTimeout(this.debounce);
      let self = this;
      this.debounce = await setTimeout(async function() {
        self.loadingDocuments = true;
        await self.getDocuments({
          project_code: self.isProject
            ? self.getCodeProjectFromParamsOrQuery
            : undefined,
          pre_project_code: self.isPresale
            ? self.$route.params.codePresale
            ? self.$route.params.codePresale : self.$route.query.code : undefined,
          document_type_filter: self.filters.document_type_filter
            ? self.filters.document_type_filter
            : undefined,
          assigned_area_filter: self.filters.assigned_area_filter
            ? self.filters.assigned_area_filter
            : undefined,
          since: self.filters.date_start
            ? `${self.filters.date_start}`
            : undefined,
          until: self.filters.date_end ? `${self.filters.date_end}` : undefined,
          general_filter:
            (self.filters.onlyFolders || !self.filters.onlyFolders) &&
            self.filters.onlySubFolders &&
            self.filters.onlyNameDocuments
              ? self.filters.filter
              : undefined,
          folder_filter:
            self.filters.onlyFolders &&
            self.filters.onlySubFolders &&
            !self.filters.onlyNameDocuments
              ? self.filters.filter
              : undefined,
          parent_folder_filter:
            self.filters.onlyFolders &&
            !self.filters.onlySubFolders &&
            !self.filters.onlyNameDocuments
              ? self.filters.filter
              : undefined,
          children_folder_filter:
            !self.filters.onlyFolders &&
            self.filters.onlySubFolders &&
            !self.filters.onlyNameDocuments
              ? self.filters.filter
              : undefined,
          document_type_filter: self.filters.document_type_filter
            ? self.filters.document_type_filter
            : self.filters.onlyNameDocuments &&
              !self.filters.onlyFolders &&
              !self.filters.onlySubFolders &&
              !self.filters.document_type_filter
            ? self.filters.filter
            : undefined,
        });
        self.getTotalPercentageProjectOrPresale({
          project_code: self.isProject
            ? self.getCodeProjectFromParamsOrQuery
            : undefined,
          pre_project_code: self.isPresale
            ? self.$route.params.codePresale
            ? self.$route.params.codePresale
            : self.$route.query.code
            : undefined,
        });
        self.loadingDocuments = false;
      }, self.debounceTime);
    },
    getIconMaterialFromExtension(extension) {
      return getIconMaterialFromExtension(extension);
    },
    async openModalPreviewDocument(documentFile) {
      this.$swal
        .fire({
          icon: "info",
          title: "Atención",
          text:
            "Esta acción registrará el documento como visto por el usuario, ¿estás seguro de continuar?",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#4285F4",
        })
        .then(async (result) => {
          if (result.value) {
            this.registerLogViewDocument({
              document_id: documentFile.id,
              user_email: this.user.email,
            });
            this.currentDocumentName = this.isPresale
              ? `${this.$route.params.codePresale || this.$route.query.code }-${this.$route.query.presale_name}-${documentFile.document_type.name}.${documentFile.extension}`
              : `${this.getCodeProjectFromParamsOrQuery}-${
                  this.currentProject ? this.currentProject.name : "proyecto"
                }-${
                  documentFile && documentFile.document_type
                    ? documentFile.document_type.name
                    : "documento"
                }.${documentFile.extension}`;
            this.currentDocument = documentFile;
            this.dialogPreviewDocument = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeModalPreviewDocument() {
      this.currentDocumentName = null;
      this.currentDocument = null;
      this.dialogPreviewDocument = false;
    },
    openModalUploadDocument(document, documentRequired = null) {
      if (documentRequired) {
        this.$refs.modalUploadDocument.setDocumentFromRequired(
          documentRequired,
        );
      }
      this.currentDocument = document;
      this.dialogUploadDocument = true;
    },
    openModalFilterDocuments() {
      this.dialogFilterDocuments = true;
    },
    openModalMaintainers() {
      this.dialogMaintainers = true;
    },
    openModalCreateProjectFromPresale() {
      this.dialogCreateProjectFromPresale = true;
    },
    closeModalFilterDocuments() {
      this.dialogFilterDocuments = false;
    },
    closeModalUploadDocument() {
      this.currentDocument = null;
      this.dialogUploadDocument = false;
    },
    closeModalMaintainers() {
      this.dialogMaintainers = false;
    },
    closeModalCreateProjectFromPresale() {
      this.dialogCreateProjectFromPresale = false;
    },
    sendDeleteDocument(document) {
      let self = this;
      this.$swal
        .fire({
          icon: "warning",
          title: `¿Estás seguro de eliminar este documento: <b>${document.name}</b> ?`,
          text: "",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "red",
          allowOutsideClick: false,
        })
        .then(async (result) => {
          if (result.value) {
            this.loading = true;
            const response = await this.deleteDocument({
              document_id: document.id,
              user: self.user.email,
            });
            if (response.status == 202 || response.status == 200) {
              this.$swal.fire({
                icon: "success",
                title: "Documento eliminado correctamente!!!",
                text: "",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 5000,
                timerProgressBar: true,
              });
              this.getDocumentsData();
            }
            if (!response.status || response.status === 400) {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: response.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 10000,
                timerProgressBar: true,
              });
            }
            this.loading = false;
          }
        });
    },
    checkForDocuments(folder) {
      let hasDocuments = false;
      if (
        folder.folder_document_types &&
        folder.folder_document_types.some((document) => document.required)
      ) {
        hasDocuments = true;
      }
      if (folder.children && folder.children.length > 0) {
        folder.children
          .filter((item) => item.status && item.children)
          .forEach((subfolder) => {
            if (this.checkForDocuments(subfolder)) {
              hasDocuments = true;
            }
          });
      }
      return hasDocuments;
    },
    IsSaleFolder(folder) {
      return folder.name === NAME_FOLDER_SALE_RESIDENTIAL;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      totalPercentageProjectOrPresale:
        "project/totalPercentageProjectOrPresale",
      currentPresale: "presale/presale",
      documents: "document/documents",
      foldersFromProjectOrPresale: "document/foldersFromProjectOrPresale",
      dataEmployees: "maintainers/employees",
    }),
    appIsLoadedInIframe(){
      return isProjectLoadedInIframe()
    },  
    isPresaleReadyToCreateProject() {
      return (
        this.foldersFromProjectOrPresale.every(
          (folder) => folder.is_pre_project_ready,
        ) && this.$route.query.have_project == "false"
      );
    },
    hasSelectedCubage() {
      return this.selectedDocuments.length > 0 && 
            this.selectedDocuments.some(doc => doc.is_cubicacion);
        },
    getTitleFromIsProjectOrPresale() {
      if (this.isProject) {
        return "Proyecto";
      }
      if (this.isPresale) {
        return "Preventa";
      }
      return "-";
    },
    getCodeFromIsProjectOrPresale() {
      if (this.isProject) {
        return this.getCodeProjectFromParamsOrQuery;
      }
      if (this.isPresale) {
        return this.$route.params.codePresale || this.$route.query.code;
      }
      return "-";
    },
    getNameFromIsProjectOrPresale() {
      if (this.isProject && this.currentProject) {
        return this.currentProject.name;
      }
      if (this.isPresale) {
        return this.$route.query.presale_name;
      }
      return "-";
    },
    isPresaleNotBusinessUnitResidential() {
      return (
        this.currentPresale &&
        this.currentPresale.business_unit.code !==
          BUSINESS_UNIT_RESIDENTIAL_CODE
      );
    },
    isEnabledCreateButton() {
      if (this.isPresaleNotBusinessUnitResidential) {
        return false;
      }
      if (this.currentUserIsSuperAdmin) {
        return true;
      } else {
        if (
          this.currentPresale &&
          this.currentPresale.business_unit &&
          this.dataEmployees &&
          this.dataEmployees.employees[0] &&
          this.dataEmployees.employees[0].cost_center
        ) {
          const hasPermission = PERMISSION_FOR_CECO.some((permission) => {
            return (
              permission.business_unit_code ===
                this.currentPresale.business_unit.code &&
              permission.cecos.includes(
                this.dataEmployees.employees[0].cost_center.code,
              )
            );
          });

          return hasPermission;
        } else {
          return false;
        }
      }
    },
    verifyUserBelongsToCgestionCostCenter() {
      return (
        this.dataEmployees.employees.length &&
        this.dataEmployees.employees.find(
          (employee) =>
            employee.cost_center.code == COST_CENTER_MANAGMENT_CONTROL ||
            employee.cost_center.code == NEW_COST_CENTER_MANAGMENT_CONTROL,
        )
      );
    },
    permissionToEditMaintainerDocument() {
      if (this.currentPresale && this.user) {
        return PERMISSION_FROM_BUSINESS_UNIT_TO_MODIFY_MAINTAINER_DOCUMENTS[
          this.currentPresale.business_unit.code
        ].includes(this.user.email);
      }
      return false;
    },
    getCodeProjectFromParamsOrQuery(){
      return this.$route.params.codigoProyecto || this.$route.query.code  
    }
  },
  watch: {
    "filters.onlyFolders": function(newValue) {
      if (newValue) {
        this.filters.onlyDocuments = false;
      }
    },
    "filters.onlyDocuments": function(newValue) {
      if (newValue) {
        this.filters.onlyFolders = false;
      }
    },
    "user": function(newValue){
      console.log(newValue)
      if(newValue){
        this.getEmployeeData()
      }
    }
  },
};
</script>

<style>
.gap-10 {
  gap: 10px;
}

#titleContainer {
  word-wrap: break-word;
  white-space: normal;
}

@media (max-width: 1600px) {
  #buttons {
    width: 100%;
  }
}

@media (max-width: 985px) {
  #name {
    width: 45%;
    max-width: 45%;
  }
  #chip {
    width: 45%;
    max-width: 45%;
  }
}
</style>


